var disinfExt = require("../extensions/disinf") ;

const PRODUCTS = {} ;

PRODUCTS.BAYROL = {
    pool: {
        CL: {
            SHOCK: ["CHLORIKLAR", "CHLORIFIX", "CHLORYTE"],
            LONG: ["CHLORILONG_5F","CHLORILONG", "CHLORILONG_BLOC",  "VARITAB", "MULTIBLOC", 
            "MULTILONG", "C_AND_E", "CHLORE_5F", "CHLORILIQUE_C", "CHLORYTE_STICKS"],
        },
        O2: {
            SHOCK: ["BAYROSHOCK"],
            LONG: ["S_AND_E_20", "S_AND_E_30", "SOFTSWIM_MULTI", "BAYROSOFT_LIGHT"],
        },
        BR: {
            SHOCK: ["AQUABROME_REGENERATOR", "CHLORYTE"],
            LONG: ["AQUABROME"],
        },
        ALG: [ "DESALGINE_JET", "DESALGINE" ]
    },
    spa: {
        CL: {
            SHOCK: ["CL_MICROBILLE", "DISINF_PLUS"],
            LONG: ["CL_MICROBILLELONG", "CHLORILIQUE_C"],
        },
        O2: {
            SHOCK: ["ACTIVE_OXY_SPATIME","CL_MICROBILLE", "DISINF_PLUS", "BAYROSOFT_LIGHT"],
            LONG: ["OXY_SPATIME", "BAYROSOFT_LIGHT"],
        },
        BR: {
            SHOCK: ["CL_MICROBILLE", "DISINF_PLUS"],
            LONG: ["BROME_SPATIME"],
        },
        ALG: [ "DESALGINE_JET", "DESALGINE" ]
    },
    removeNotAllowedProducts: function (array, input, excludedProducts){
        var result = [] ;
        array.forEach(function(product){
            if(excludedProducts && excludedProducts.indexOf(product) !== -1){
                return;
            }
            if(product === "CHLORILONG") {
                if (input.pool.volume >= 15) {
                    result.push(product);
                }
            }else if(product === "CHLORILONG_BLOC") {
                if (input.pool.volume >= 20 && input.pool.volume <= 210) {
                    result.push(product);
                }
            }else if(product === "CHLORYTE_STICKS") {
                if (input.pool.volume >= 15 && input.pool.volume <= 120) {
                    result.push(product);
                }
            }else if(product === "CHLORILONG_5F"){
                if(input.pool.volume >= 15 && input.pool.volume <= 210 &&
                    ["GLASS", "SAND", "CARTRIDGE", "POCKET"].indexOf(input.pool.filter) !== -1) {
                    result.push(product) ;
                }
            }else if(product === "CHLORE_5F"){
                if(input.pool.volume >= 0.6 && input.pool.volume < 15 &&
                ["GLASS", "SAND", "CARTRIDGE", "POCKET"].indexOf(input.pool.filter) !== -1) {
                    result.push(product);
                }
            }else if(product === "VARITAB"){
                if(input.pool.volume >= 20 && input.pool.volume <= 210 &&
                ["GLASS", "SAND"].indexOf(input.pool.filter) !== -1) {
                    result.push(product);
                }
            }else if(product === "MULTIBLOC") {
                if(input.pool.volume >= 25 && input.pool.volume <= 210 &&
                ["GLASS", "SAND", "CARTRIDGE", "POCKET"].indexOf(input.pool.filter) !== -1) {
                    result.push(product);
                }
            }else if(product === "MULTILONG") {
                if(input.pool.volume >= 30 && input.pool.volume <= 200 &&
                ["GLASS", "SAND"].indexOf(input.pool.filter) !== -1) {
                    result.push(product);
                }
            }else if(product === "S_AND_E_20") {
                if(input.pool.volume >= 11 && input.pool.volume <= 100 &&
                ["GLASS", "SAND", "CARTRIDGE", "POCKET"].indexOf(input.pool.filter) !== -1) {
                    result.push(product);
                }
            }else if(product === "S_AND_E_30") {
                if(input.pool.volume >= 21 && input.pool.volume <= 120 &&
                ["GLASS", "SAND", "CARTRIDGE", "POCKET"].indexOf(input.pool.filter) !== -1) {
                    result.push(product);
                }
            }else if(product === "C_AND_E") {
                if(input.pool.volume >= 11 && input.pool.volume <= 100 &&
                    ["GLASS", "SAND", "CARTRIDGE", "POCKET"].indexOf(input.pool.filter) !== -1) {
                    result.push(product);
                }
            }else if(product === "DISINF_PLUS") {
                if(input.pool.volume >= 0.21 && input.pool.volume <= 4.9) {
                    result.push(product);
                }
            }else if(product === "BROME_SPATIME") {
                if(input.pool.volume >= 0.21 && input.pool.volume <= 10.2) {
                    result.push(product);
                }
            }else if(product === "CHLORIKLAR" || product === "CHLORIFIX" || product === "CHLORYTE") {
                if(input.pool.disinf !== "O2" || !input.pool.long || input.pool.long.length !== 1 || input.pool.long[0] !== "BAYROSOFT_LIGHT") {
                    //if not oxygen or not only bayroft light (if only bayrosoft light don't add it)
                    result.push(product);
                }
            }else if(product === "SUPERFLOCK_PLUS") {
                if(["GLASS", "SAND"].indexOf(input.pool.filter) !== -1) {
                    result.push(product);
                }
            }else{
                result.push(product) ;
            }
        }) ;
        return result;
        // return result.filter(function(p){
        //     //filter by country availability
        //     return disinfExt.COUNTRY_AVAILABILITY[p][VeloxWebView.country.get()] ;
        // }) ;
    }
}

PRODUCTS.AQUAPURE = {
    pool: {
        CL: {
            SHOCK: ["CHLORE_CHOC_PASTILLE_AQUAPURE", "CHLORE_RAPIDE_GRANULES_AQUAPURE"],
            LONG: ["CHLORE_LENT_GALETS_250_AQUAPURE","CHLORE_LENT_GALETS_500_AQUAPURE", 
            "CHLORE_MULTIACTIONS_GALETS_250_AQUAPURE",  "CHLORE_MULTIACTIONS_GALETS_500_AQUAPURE", 
            "CHLORE_LIQUIDE_AQUAPURE"],
        },
        O2: {
            SHOCK: ["OXYGEN_ACTIF_AQUAPURE"],
            LONG: ["CHLORE_LENT_GALETS_250_AQUAPURE","CHLORE_LENT_GALETS_500_AQUAPURE", 
            "CHLORE_MULTIACTIONS_GALETS_250_AQUAPURE",  "CHLORE_MULTIACTIONS_GALETS_500_AQUAPURE", 
            "CHLORE_LIQUIDE_AQUAPURE"],
        },
        BR: {
            SHOCK: ["OXYDANT_CHOC_AQUAPURE"],
            LONG: ["BROME_PASTILLES_AQUAPURE"],
        },
        ALG: [ "ANTI_ALGUE_AQUAPURE", "ANTI_ALGUE_MULTIACTIONS_AQUAPURE" ]
    },
    spa: {
        CL: {
            SHOCK: ["CHLORE_CHOC_PASTILLE_AQUAPURE", "CHLORE_RAPIDE_GRANULES_AQUAPURE"],
            LONG: ["CHLORE_LENT_GALETS_250_AQUAPURE","CHLORE_LENT_GALETS_500_AQUAPURE", 
            "CHLORE_MULTIACTIONS_GALETS_250_AQUAPURE",  "CHLORE_MULTIACTIONS_GALETS_500_AQUAPURE", 
            "CHLORE_LIQUIDE_AQUAPURE"],
        },
        O2: {
            SHOCK: ["OXYGEN_ACTIF_AQUAPURE"],
            LONG: ["CHLORE_LENT_GALETS_250_AQUAPURE","CHLORE_LENT_GALETS_500_AQUAPURE", 
            "CHLORE_MULTIACTIONS_GALETS_250_AQUAPURE",  "CHLORE_MULTIACTIONS_GALETS_500_AQUAPURE", 
            "CHLORE_LIQUIDE_AQUAPURE"],
        },
        BR: {
            SHOCK: ["OXYDANT_CHOC_AQUAPURE"],
            LONG: ["BROME_PASTILLES_AQUAPURE"],
        },
        ALG: [ "ANTI_ALGUE_AQUAPURE", "ANTI_ALGUE_MULTIACTIONS_AQUAPURE" ]
    },
    removeNotAllowedProducts: function (array, input, excludedProducts){
        var result = [] ;
        array.forEach(function(product){
            if(excludedProducts && excludedProducts.indexOf(product) !== -1){
                return;
            }
            if(product === "CHLORE_LENT_GALETS_250_AQUAPURE") {
                if (input.pool.volume >= 15) {
                    result.push(product);
                }
            }else if(product === "CHLORE_LENT_GALETS_500_AQUAPURE") {
                if (input.pool.volume >= 20 && input.pool.volume <= 250) {
                    result.push(product);
                }
            }else if(product === "CHLORE_MULTIACTIONS_GALETS_250_AQUAPURE") {
                if (input.pool.volume >= 15 && input.pool.volume <= 200 &&
                    ["GLASS", "SAND", "CARTRIDGE", "POCKET"].indexOf(input.pool.filter) !== -1) {
                    result.push(product);
                }
            }else if(product === "CHLORE_MULTIACTIONS_GALETS_500_AQUAPURE"){
                if(input.pool.volume >= 20 && input.pool.volume <= 250 &&
                    ["GLASS", "SAND", "CARTRIDGE", "POCKET"].indexOf(input.pool.filter) !== -1) {
                    result.push(product) ;
                }
            }else if(product === "FLOCULANT_CARTOUCHE_AQUAPURE"){
                if(input.pool.volume >= 1 && input.pool.volume < 200 &&
                ["GLASS", "SAND"].indexOf(input.pool.filter) !== -1) {
                    result.push(product);
                }
            }else if(product === "SUPERFLOCK_PLUS") {
                if(["GLASS", "SAND"].indexOf(input.pool.filter) !== -1) {
                    result.push(product);
                }
            }else{
                result.push(product) ;
            }
        }) ;
        return result;
        // return result.filter(function(p){
        //     //filter by country availability
        //     return disinfExt.COUNTRY_AVAILABILITY[p][VeloxWebView.country.get()] ;
        // }) ;
    }
}

module.exports = PRODUCTS;